
<div class="gridheight mat-elevation-z8 viewport">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
    <ng-container matColumnDef="expandIcon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"
        style="width: 32px;border-right: 1px solid currentColor;padding-right: 24px;text-align: center;">
      </td>
    </ng-container>

    <ng-container matColumnDef="streamId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
      <td mat-cell *matCellDef="let element"> {{element.streamId}} </td>
    </ng-container>

    <ng-container matColumnDef="streamName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Stream Name </th>
      <td mat-cell *matCellDef="let element"> {{element.streamName}} </td>
    </ng-container>

    <ng-container matColumnDef="foodGroupName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Stream Group </th>
      <td mat-cell *matCellDef="let element"> {{ element.foodGroupName  }} </td>
    </ng-container>

    <ng-container matColumnDef="foodMatrixName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Stream Matrix </th>
      <td mat-cell *matCellDef="let element"> {{element.foodMatrixName}} </td>
    </ng-container>

    <ng-container matColumnDef="strength">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Stream Strength </th>
      <td mat-cell *matCellDef="let element"> {{element.strength}} </td>
    </ng-container>
    <ng-container matColumnDef="projectedVolume">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Projected<br/>Volume </th>
      <td mat-cell *matCellDef="let element"> {{element.projectedVolume}} </td>
    </ng-container>
    <ng-container matColumnDef="statusDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
      <td mat-cell *matCellDef="let element"> {{element.statusDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="commissionEligibleDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Commission<br/>Eligible </th>
      <td mat-cell *matCellDef="let element"> {{element.commissionEligibleDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="rebateEligibleDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Rebate<br/>Eligible </th>
      <td mat-cell *matCellDef="let element"> {{element.rebateEligibleDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="siteNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Oracle<br/>Site NUmber </th>
      <td mat-cell *matCellDef="let element"> {{element.siteNumber}} </td>
    </ng-container>
    <ng-container matColumnDef="noOfBins">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Bins# </th>
      <td mat-cell *matCellDef="let element"> {{element.noOfBins}} </td>
    </ng-container>
    <ng-container matColumnDef="haulerName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Hauler </th>
      <td mat-cell *matCellDef="let element"> {{element.haulerName}} </td>
    </ng-container>
    <ng-container matColumnDef="avG_COD">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> AVG COD </th>
      <td mat-cell *matCellDef="let element"> {{element.avG_COD}} </td>
    </ng-container>
    <ng-container matColumnDef="avG_TVS">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> AVG TVS </th>
      <td mat-cell *matCellDef="let element"> {{element.avG_TVS}} </td>
    </ng-container>
    <ng-container matColumnDef="avG_TS">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> AVG TS </th>
      <td mat-cell *matCellDef="let element"> {{element.avG_TS}} </td>
    </ng-container>
    <ng-container matColumnDef="avG_TotalCarbon">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> AVG Carbon </th>
      <td mat-cell *matCellDef="let element"> {{element.avG_TotalCarbon}} </td>
    </ng-container>
    <ng-container matColumnDef="avG_TotalNitrogen">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> AVG Nitrogen </th>
      <td mat-cell *matCellDef="let element"> {{element.avG_TotalNitrogen}} </td>
    </ng-container>
    <ng-container matColumnDef="codRequiredDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> COD<br/>Required </th>
      <td mat-cell *matCellDef="let element"> {{element.codRequiredDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="codEmail">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> COD Email </th>
      <td mat-cell *matCellDef="let element"> {{element.codEmail}} </td>
    </ng-container>
    <ng-container matColumnDef="toteDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Is Tote </th>
      <td mat-cell *matCellDef="let element"> {{element.toteDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="expenseDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Is Expense </th>
      <td mat-cell *matCellDef="let element"> {{element.expenseDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="outboundDescription">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Is Outbound </th>
      <td mat-cell *matCellDef="let element"> {{element.outboundDescription}} </td>
    </ng-container>
    <ng-container matColumnDef="isCustomerReferenceRequiredDesc">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer Reference <br />Required </th>
      <td mat-cell *matCellDef="let element"> {{element.isCustomerReferenceRequiredDesc}} </td>
    </ng-container>
    <ng-container matColumnDef="disposalMethod">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Disposal Method </th>
      <td mat-cell *matCellDef="let element"> {{element.disposalMethod}} </td>
    </ng-container>
    
    <ng-container matColumnDef="marketName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Market Name </th>
      <td mat-cell *matCellDef="let element"> {{element.marketName}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button [matMenuTriggerFor]="menu"
          #menuTrigger="matMenuTrigger"
          (click)="loadMenuDataAndOpen(row, menuTrigger)">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openAddEditForm(row, 'Edit')">
            <mat-icon matListIcon>edit</mat-icon>
            <span matLine>Edit</span>
          </button>
          @if(controlPermissions.deleteStream){
            <button mat-menu-item (click)="deleteStream(row.streamId, row.streamName)" style="color: red;">
              <mat-icon matListIcon color="warn">delete</mat-icon>
              <span matLine>Delete</span>
            </button>
          }
          <button mat-menu-item (click)="showRecurringLoads(row.streamId)">
            <mat-icon matListIcon>autorenew</mat-icon>
            <span matLine>Recurring Load</span>
          </button>
          <button mat-menu-item (click)="showSamplingFrequencies(row.streamId)">
            <mat-icon matListIcon>schedule</mat-icon>
            <span matLine>Sampling Frequency</span>
          </button>
          <button
              mat-menu-item
              (click)="openAttachDocuments(row.streamId, row.streamName)"
            >
            <mat-icon matListIcon>attach_file_add</mat-icon>
            <span matLine>Attach docs</span>
          </button>
          <button
              mat-menu-item
              [disabled]="row.loadSlip == false"
              [ngClass]="{ iconBGColor: row.loadSlip == true }"
              (click)="openViewDocsDialog(row.streamId, row.streamName)"
            >
            <mat-icon matListIcon>visibility</mat-icon>
            <span matLine>View docs</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
          No data matching the filter.
        </td>
      </tr> -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
          No Streams matching the filter.
        </td>
      </tr>
  </table>
</div>
